import React, { useContext, useEffect, useState } from 'react';

import AlgoliaClient from '../search/AlgoliaClient';
import DomainSearchLoadingElements from '@fec/frontend/elements/search/domain-search-results/domain-search-loading-elements';
import DomainSearchResults from '@fec/frontend/elements/search/domain-search-results/domain-search-results';
import { translate } from '../searchHelpers';
import { searchContextStore } from '../search/SearchContextProvider';

/**
 * Stays hidden until search() is called. Then shows the loading state, fetches the search results and displays them.
 * If none were found or an error occurred, the component will hide itself again.
 */
export const DomainSearchContainer = (props) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wasEverSearched, setWasEverSearched] = useState(false);
  const [items, setItems] = useState([]);

  const { state: searchContext } = useContext(searchContextStore);

  const _t = translate.bind(
    null,
    searchContext.searchConfig,
    searchContext.translations,
  );
  const searchClient = new AlgoliaClient(
    props.algoliaIndex,
    searchContext.translations,
    props.isWebview,
    searchContext.searchConfig.domainSearch,
  );

  useEffect(() => {
    search();
  }, [searchContext.searchParams.q]);

  const search = () => {
    if (searchContext.searchParams.q === '') {
      // Reset search results if search string is reset
      setItems([]);
      return;
    }

    setIsLoading(true);
    setWasEverSearched(true);
    setError(null);

    searchClient.getDomains(searchContext.searchParams.q).then(
      (result) => {
        setItems(result.hits);
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        setError(error);
      },
    );
  };

  // Hide (= don't render anything)
  // ...until the first search
  // ...or when nothing was found
  // ...or when an error was encountered
  if (error || !wasEverSearched || (!isLoading && items.length === 0)) {
    return null;
  }

  return (
    <div className="search-container" aria-live="polite">
      <h3 className="domain-teaser__title">{_t('bereiche')}</h3>
      {isLoading ? (
        <DomainSearchLoadingElements
          nrOfElements={searchContext.searchConfig.domainSearch.limit}
        />
      ) : (
        <DomainSearchResults items={items} />
      )}
    </div>
  );
};
